<sim-basic-material-dialog
	(closeClicked)="close({action: 'cancel'})"
	[finished]="finished"
	[headerText]="T.CREATE_CAMERA_DIALOG_HEADER_TXT | translate"
	[headerIcon]="{fontIcon: 'fa-video-plus', fontSet: 'fad'}"
	[matDialogData]="data"
	[rect]="rect"
	[smallHeader]="true"
>
	<ng-container dialogContent>
		<div>
			<mat-form-field color="accent" style="width: 100%">
				<mat-label>
					{{ T.CONFIGURATION_EDITOR_CAMERA_TEMPLATE_NUMBER_OF_CAMERAS | translate }}
				</mat-label>
				<input #inputAmount="ngModel" [(ngModel)]="amount" matInput max="100" min="1" name="inputAmount" required type="number" />
			</mat-form-field>
			<mat-form-field color="accent" style="width: 100%">
				<mat-label>
					{{ T.CONFIGURATION_EDITOR_CAMERA_TEMPLATE_START_CAMERA_NUMBER | translate }}
				</mat-label>
				<input
					#inputStartCameraNumber="ngModel"
					[(ngModel)]="startCameraNumber"
					matInput
					max="1000"
					min="0"
					name="inputStartCameraNumber"
					required
					type="number"
				/>
			</mat-form-field>
			<mat-form-field color="accent" style="width: 100%">
				<mat-label [innerHTML]="T.CONFIGURATION_EDITOR_CAMERA_TEMPLATE_NAME | translate" />
				<input
					#inputName="ngModel"
					[(ngModel)]="nameTemplate"
					matInput
					name="inputName"
					required
					style="margin-top: 10px"
					type="text"
				/>
			</mat-form-field>
			<mat-form-field color="accent" style="width: 100%">
				<mat-label [innerHTML]="T.CONFIGURATION_EDITOR_CAMERA_TEMPLATE_ADDRESS | translate" />
				<input
					#inputAddress="ngModel"
					[(ngModel)]="addressTemplate"
					matInput
					name="inputAddress"
					required
					style="margin-top: 10px"
					type="text"
				/>
			</mat-form-field>

			<mat-form-field color="accent" style="width: 100%">
				<mat-label>
					{{ T.CONFIGURATION_EDITOR_CAMERA_TYPE | translate }}
				</mat-label>
				<mat-select [(ngModel)]="selectedCameraType" name="selectedCameraType" required>
					@for (cameraType of cameraTypes; track cameraType) {
						<mat-option [value]="cameraType.value">
							{{ cameraType.name }}
						</mat-option>
					}
				</mat-select>
			</mat-form-field>
		</div>
	</ng-container>
	<ng-container actions>
		<sim-button (onClick)="cancel()" [icon]="{fontSet: 'fal', fontIcon: 'fa-times'}" [label]="T.BUTTON_CANCEL" [color]="'warn'" />

		<sim-button
			(onClick)="ok()"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
			[label]="T.CONFIGURATION_EDITOR_CAMERA_OK"
			[color]="'accent'"
		/>
	</ng-container>
</sim-basic-material-dialog>
